<template>
  <div class="table-wrapper">
    <table 
      class="table has-smallest-font mt-3"
      :class="{ 'is-fullwidth': isFullwidth }">
      <thead>
        <tr class="has-text-centered">
          <th
            v-for="(header, i) in headers"
            :key="i">
            {{ header.label }}
            <span 
              v-if="header.label == 'Area' && hasFootnotes"
              class="has-text-weight-normal">
              [1]
            </span>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td class="category has-text-weight-bold" :rowspan="irregularMpa ? 3 : 2">
            Material
          </td>
          <td class="description">
            <div class="has-text-weight-bold">
              Solar Facing
            </div>
            <div class="help">
              Seamlessly integrated solar cell
            </div>
          </td>
          <td class="area has-text-weight-bold has-text-right">
            {{ wallMpa.measure | commasep(0) }}
          </td>
          <td class="unit has-text-weight-bold">
            Sq. Ft
          </td>
        </tr>

        <tr>
          <td class="description">
            <div class="has-text-weight-bold">
              Backing System
            </div>
            <div class="help">
              AirLayer&trade; backing system. Including Anchor plate 
              installation and a cross section of installation method.
            </div>
          </td>
          <td class="area has-text-weight-bold has-text-right">
            {{ wallMpa.measure | commasep(0) }}
          </td>
          <td class="unit has-text-weight-bold">
            Sq. Ft
          </td>
        </tr>

        <tr v-if="irregularMpa">
          <td class="description">
            <div class="has-text-weight-bold">
              Fabricated Solar Cladding
            </div>
          </td>
          <td class="area has-text-weight-bold has-text-right">
            {{ irregularMpa.measure | commasep(0) }}
          </td>
          <td class="unit has-text-weight-bold">
            L. Ft
          </td>
        </tr>

        <tr>
          <td class="category has-text-weight-bold">
            Electricity
          </td>
          <td class="description">
            <div class="has-text-weight-bold">
              Approx. Energy Yield
            </div>
            <div class="help">
              The electricity generated by the system.
            </div>
          </td>
          <td class="area has-text-weight-bold has-text-right">
            {{ wallMpa.system_size }}
          </td>
          <td class="unit has-text-weight-bold">
            kW
          </td>
        </tr>

        <tr>
          <td class="category has-text-weight-bold" rowspan="3">
            Service
          </td>
          <td class="description">
            <div class="has-text-weight-bold">
              Shop Drawings
            </div>
            <div class="help">
              Panel Layout & Engineering
            </div>
          </td>
          <td class="area has-text-weight-bold">
          </td>
          <td class="unit has-text-weight-bold">
            Set
          </td>
        </tr>

        <tr>
          <td class="description">
            <div class="has-text-weight-bold">
              Packaging and Delivery
            </div>
          </td>
          <td class="area has-text-weight-bold has-text-right">
            {{ runs }}
          </td>
          <td class="unit has-text-weight-bold">
            Runs
          </td>
        </tr>

        <tr>
          <td class="description">
            <div class="has-text-weight-bold">
              Installation and Maintenance
              <span v-if="hasFootnotes" class="has-text-weight-normal">[2]</span>
            </div>
          </td>
          <td class="area has-text-weight-bold has-text-right">
            Included
          </td>
          <td class="unit has-text-weight-bold">
            Crew
          </td>
        </tr>
      </tbody>

      <tfoot class="has-text-weight-bold">
        <tr>
          <td class="category" :rowspan="hasMpaPrice + +hasDpaPrice">
            Pricing (CAD$)
          </td>
          <template v-if="hasMpaPrice">
            <td class="description">
              <span v-if="hasMpaPrice && hasDpaPrice">
                OPTION 1: MPA
              </span> 
              <span v-else>Total MPA Price</span> 
              <span class="has-text-weight-normal"> (Excl. HST)</span>
            </td>
            <td class="area">
              {{ mpaPrice | currency(0) }}
            </td>
            <td class="unit"></td>
          </template>

          <template v-if="!hasMpaPrice && hasDpaPrice">
            <td class="description">
              Total DPA Price
              <span class="has-text-weight-normal"> (Excl. HST)</span>
            </td>
            <td class="area">
              {{ dpaPrice | currency(0) }}
            </td>
            <td class="unit"></td>
          </template>
        </tr>

        <tr v-if="hasMpaPrice && hasDpaPrice">
          <td class="description">
            <span v-if="hasMpaPrice && hasDpaPrice">
              OPTION 2: DPA
            </span> 
            <span v-else>Total DPA Price</span> 
            <span class="has-text-weight-normal"> (Excl. HST)</span>
          </td>
          <td class="area">
            {{ dpaPrice | currency(0) }}
          </td>
          <td class="unit"></td>
        </tr>

        <!-- <tr>
          <td class="description">
            Batteries & Inverters
          </td>
          <td class="area">
            {{ battery.price | currency(0) }}
          </td>
          <td class="unit"></td>
        </tr>

        <tr>
          <td class="description">
            Mitrex credit 
            <span class="has-text-weight-normal">
              [2]
            </span>
          </td>
          <td class="area">
            - {{ wall.what_should_be_paid - wall.price | currency(0) }}
          </td>
          <td class="unit"></td>
        </tr> -->

        <!-- <tr>
          <td class="description">
            HST
          </td>
          <td class="area">
            {{ wall.price * 0.13 | currency(0) }}
          </td>
          <td class="unit"></td>
        </tr>

        <tr>
          <td class="description">
            Total cost including HST
          </td>
          <td class="area">
            {{ wall.price * 1.13 | currency(0) }}
          </td>
          <td class="unit"></td>
        </tr> -->
      </tfoot>
    </table>
    
    <div v-if="hasFootnotes" class="help">
      <div>
        [1] Area is including material waste.
      </div>
      <div>
        [2] Maintenance is included for the period of the energy contract.
      </div>
    </div>
    <!-- <div class="help">
      [2] Credit for the solar technology to lower up-front costs.
    </div>   -->
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    estimation: {
      type: Object
    },
    hasMpaPrice: {
      type: Boolean,
      default: true
    },
    hasDpaPrice: {
      type: Boolean,
      default: true
    },
    isFullwidth: {
      type: Boolean,
      default: false
    },
    hasFootnotes: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      headers: [
        { label: 'Item' },
        { label: 'Description' },
        { label: 'Area' },
        { label: 'Unit' }
      ]
    }
  },
  computed: {
    summaryObjectMpa({ estimation }) {
      return estimation.estimation_summary;
    },
    summaryObjectDpa({ estimation }) {
      return estimation.estimation_summary_dpa;
    },
    irregularMpa({ summaryObjectMpa }) {
      return summaryObjectMpa.irregular_price_by_material.filter(
        d => d.product_brand == 'Mitrex'
      ).reduce((a,b) => {
        a['measure'] = a['measure'] + +b['sum_linear_ft'];
        a['what_should_be_paid'] = a['what_should_be_paid'] + +b['total_cost'];
        a['price'] = a['price'] + +b['adjusted_total_cost'];
        return a
      }, {
        measure: 0, 
        what_should_be_paid: 0, 
        price: 0
      });
    },
    irregularDpa({ summaryObjectDpa }) {
      return summaryObjectDpa.irregular_price_by_material.filter(
        d => d.product_brand == 'Mitrex'
      ).reduce((a,b) => {
        a['measure'] = a['measure'] + +b['sum_linear_ft'];
        a['what_should_be_paid'] = a['what_should_be_paid'] + +b['total_cost'];
        a['price'] = a['price'] + +b['adjusted_total_cost'];
        return a
      }, {
        measure: 0, 
        what_should_be_paid: 0, 
        price: 0
      });
    },
    wallMpa({ summaryObjectMpa }) {
      return summaryObjectMpa.summary.filter(
        d => d.pricing_summary.includes('solar_wall')
      ).reduce((a, b) => {
        Object.keys(a).forEach(key => {
          a[key] = a[key] + +b[key]
        })
        return a
      }, { 
        elec_proceeds_for_business: 0, 
        elec_proceeds_for_mitrex: 0, 
        measure: 0, 
        price: 0, 
        what_should_be_paid: 0,
        system_size: 0
      });
    },
    wallDpa({ summaryObjectDpa }) {
      return summaryObjectDpa.summary.filter(
        d => d.pricing_summary.includes('solar_wall')
      ).reduce((a, b) => {
        Object.keys(a).forEach(key => {
          a[key] = a[key] + +b[key]
        })
        return a
      }, { 
        elec_proceeds_for_business: 0, 
        elec_proceeds_for_mitrex: 0, 
        measure: 0, 
        price: 0, 
        what_should_be_paid: 0,
        system_size: 0
      });
    },
    mpaPrice({ wallMpa, irregularMpa }) {
      return wallMpa.price + irregularMpa.price;
    },
    dpaPrice({ wallDpa, irregularDpa }) {
      return wallDpa.price + irregularDpa.price;
    },
    battery({ summaryObjectMpa }) {
      return summaryObjectMpa.summary.filter(
        d => d.pricing_summary.includes('batteries')
      )[0];
    },
    runs({ value, estimation }) {
      if (estimation.no_of_runs > 0) {
        return estimation.no_of_runs
      } else if (value) {
        return value
      } else {
        return 'included'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';
@import '@/styles/detailed-pricing.scss';
</style>